<script lang="ts">
	//Formating
	import { format } from 'svelte-i18n';
	// Design system components
	import { Select, Text } from '@Shelly/shelly-design-system';
	//Helpers
	import { capFirstChar } from 'src/helpers/utilities';
	import { user_data } from 'src/stores/account/user';
	import { getDailyRangeOptions, getUserTimeZoneDate, startsWeekOnSun } from 'src/helpers/date_helper';
	// Config
	import { getTariffIntervalsChartConfig } from 'src/helpers/statistics/config/tariff_intervals';
	// Components
	import LayerChartRenderer from '../LayerChart/LayerChartRenderer.svelte';
	//Types
	import type { PowerPricesData } from 'src/types/PowerPrices';
	import type { ChartDataInterface, TimeZoneInterface } from 'src/types/Chart';

	export let powerPrices: PowerPricesData, currency: string;

	const startWeekOnSun = startsWeekOnSun(),
		rangeOptions = getDailyRangeOptions(startWeekOnSun),
		onChangeRange = (range: number) => {
			rangeValue = rangeOptions.find((el) => el.value === range);
			chartData = getTariffIntervalsChartConfig(powerPrices, currency, range, startWeekOnSun);
		},
		selectChangeRange = (e: CustomEvent | { detail: number }) => {
			onChangeRange(e.detail.value);
		};

	let rangeValue = rangeOptions[0],
		chartData: ChartDataInterface,
		userTimeZone: TimeZoneInterface;

	$: if ($user_data) {
		userTimeZone = getUserTimeZoneDate();
	}

	$: chartData = getTariffIntervalsChartConfig(
		powerPrices,
		currency,
		rangeValue.value,
		startWeekOnSun,
	);
</script>

<Text styleType="controls-large" class="mb-m text-bold">
	{$format('pricing_overview_heading', { default: 'Pricing Overview' })}
</Text>
<div class="d-flex">
	<Select
		id="select-tariff-chart-range"
		aria-label={$format('select_tariff_chart_range', {
			default: 'Select tariff chart range',
		})}
		value={rangeValue}
		size="m"
		icon="fas fa-clock-rotate-left"
		options={rangeOptions}
		on:change={selectChangeRange}
	/>
</div>
<LayerChartRenderer {chartData} />
{#if userTimeZone}
	<Text size="xs" class="mt-s tiny-styles text-secondary">
		{capFirstChar(
			$format('local_time_zone_user_account', {
				default: `local time-zone of the user account`,
			}),
		)}: {userTimeZone.tz}
		{#if userTimeZone.timeZoneOffset != 0}
			{` (${userTimeZone.timeZoneOffset > 0 ? '+' : ''}${userTimeZone.timeZoneOffset}${$format(
				'local_time_zone_from_current_time_zone',
				{
					default: 'h from current time zone',
				},
			)})`}
		{/if}
	</Text>
{/if}
